'use client';
import { ListboxOption } from '../listbox/listbox-option.component.js';

const ComboboxOption = ListboxOption;
ListboxOption.displayName = 'ComboboxOption';

export { ComboboxOption };
